import { render, staticRenderFns } from "./BaselineSingleDetails.vue?vue&type=template&id=5fa7fe28&scoped=true"
import script from "./BaselineSingleDetails.vue?vue&type=script&lang=js"
export * from "./BaselineSingleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa7fe28",
  null
  
)

export default component.exports